export default "__VITE_ASSET__T4AtitIA__"